<template>
  <v-card class="mx-1">
    <v-layout row wrap>
      <v-flex xs12 sm12>
        <v-img :src="post.main_image" height="200" min-width="100" class="ma-1"/>
      </v-flex>
      <v-flex xs12 sm12>
        <v-card-title primary-title class="py-1">
          <div style="height: 5rem">
            <div class="grey-security">{{ post.published_at }}</div>
            <div 
              :title="post.title" 
              :class="stylePostTitle"
            >
              {{ postTitle }}
            </div>
          </div>
        </v-card-title>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
export default {
  props: {
    post: { type: Object, required: true },
  },
  computed: {
    postTitle() {
      if (this.post.title.length >= 35) {
        return this.withScreen <= 330 ? `${this.post.title.slice(0, 30)}...` : `${this.post.title}`
      } else {
        return this.post.title
      }
    },
    withScreen() {
      return this.$vuetify.breakpoint.width
    },
    stylePostTitle() {
      return this.withScreen <= 330 ? 'text-12-security blue-security font-weight-bold' : 'text-17-security blue-security font-weight-bold'
    }
  },
}
</script>
<style>
  
</style>